export enum SpanTypes {
    Client = 'Client',
    Navigation = 'Navigation',
    Page = 'Page',
    Player = 'Player',
    ContentImpression = 'ContentImpression',
    PlaybackSession = 'PlaybackSession',
    PlaybackSegment = 'PlaybackSegment',
}
